var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49.9 49.9",
    style: {
      enableBackground: "new 0 0 49.9 49.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#023047;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,45.6L38.6,35c-1.1-1.1-2.8-1.1-3.9,0c-6.9,6.7-18,6.5-24.7-0.4s-6.5-18,0.4-24.7s18-6.5,24.7,0.4 c2.2,2.3,3.8,5.2,4.5,8.4c0.6,2.7,0.5,5.6-0.2,8.3c-0.4,1.3,0.4,2.7,1.8,3.1c1.3,0.4,2.7-0.4,3.1-1.8l0,0c3.2-12-4-24.4-16-27.6 s-24.4,4-27.6,16s4,24.4,16,27.6c6.9,1.8,14.3,0.3,19.9-4.2l9.1,9.1c1,1,2.6,1,3.5,0c0,0,0,0,0,0C50.1,48.2,50.1,46.6,49.1,45.6 C49.2,45.6,49.1,45.6,49.1,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,30c-0.8-0.8-2.1-0.9-3-0.3c-2.6,1.6-6,1.7-8.7,0.2c-0.9-0.5-2.1-0.4-2.9,0.3l-0.1,0.1 c-1,0.9-1,2.4-0.1,3.4c0.1,0.2,0.3,0.3,0.5,0.4c4.4,2.5,9.7,2.4,14-0.3c1.1-0.7,1.5-2.2,0.7-3.3c-0.1-0.1-0.2-0.3-0.3-0.4L30,30z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.789738f0237fba8dd694063d32b589e2.svg";
export { ForwardRef as ReactComponent };